import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Typography
} from "@mui/material";
import {
    WordPressMultiConversationChatBotShippingInformation
} from "./WordPressMultiConversationChatBotShippingInformation";
import {WordPressMultiConversationChatBotRate} from "./WordPressMultiConversationChatBotRate";
import {PARCEL_PACKAGE} from "../../Utils/Helper";
import Link from '@mui/material/Link';
import {LABEL_DOWNLOAD_URL_PREFIX, NODE_ROUTE_URI} from "../../Utils/apiUrl";
import {Fragment, useEffect, useState} from "react";
import {FlexBox} from "../Theme/CustomComponent";
import {Feedback} from "@mui/icons-material";
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';

export const WordPressMultiConversationChatBotOutputChat = ({
                                                                lng,
                                                                chat,
                                                                status,
                                                                service,
                                                                cbHandleConfirm,
                                                                cbHandleMovingService,
                                                                index,
                                                                chatLength,
                                                                packageRate,
                                                                packageLoading,
                                                                packageError,
                                                                isAbleGetPackageRate,
                                                                movingFrom,
                                                                movingTo,
                                                                emailAddress,
                                                                phoneNumber,
                                                                APIRate
                                                            }) => {

    console.log('[WordPressMultiConversationChatBotOutputChat] chat', chat);

    const RegisterLink = () => {

        const [isEmailExist, setIsEmailExist] = useState(false);
        const [loading, setLoading] = useState(false);
        const [success, setSuccess] = useState(false);
        const [error, setError] = useState(false);
        const [account, setAccount] = useState(null);

        const verifyEmail = async () => {
            try {
                let requestURL = `${NODE_ROUTE_URI}/login_middleware/verifyEmailExist`;

                const result = await axios({
                    method: 'POST',
                    url: requestURL,
                    data: {
                        email: emailAddress,
                    }
                });

                setIsEmailExist(result.data);

                return result.data;
            } catch (e) {
                return null
            }
        }

        const quickSignUp = async () => {
            try {
                let requestURL = `${NODE_ROUTE_URI}/login_middleware/quickSignupFromGuest`;

                const result = await axios({
                    method: 'POST',
                    url: requestURL,
                    data: {
                        email: emailAddress,
                        phone: phoneNumber?.replace(/\D/g, ""),
                        sendActiveEmail: true
                    }
                });

                return result.data;
            } catch (e) {
                return null
            }
        }

        const convertMovingOrder = async ({userId}) => {
            try {
                let requestURL = `${NODE_ROUTE_URI}/movingService/editMovingOrderDetailsFromGuest`;


                let data = {
                    backendOrderId: APIRate?.uucOrderId,
                    userId: userId,
                    ownerRole: 1,
                    orderSubType: "Quote"
                }


                const result = await axios({
                    method: 'PATCH',
                    url: requestURL,
                    data: data
                });

                return result.data;
            } catch (e) {
                return null
            }
        }

        const handleQuickSignUp = async () => {

            try {
                setLoading(true);
                setAccount(null);

                const accountInfo = await quickSignUp();
                setAccount(accountInfo);

                if (accountInfo?.id && APIRate?.uucOrderType?.toLowerCase() === 'moving') {
                    convertMovingOrder({userId: accountInfo?.id});
                }

                setSuccess(true);
                setError(false);

            } catch (e) {

                setSuccess(false);
                setError(true)

            } finally {
                setLoading(false);
            }
        }

        useEffect(() => {
            (async () => {
                await verifyEmail();
            })();
        }, [emailAddress]);

        console.log('[RegisterLink] email address', emailAddress);
        console.log('[RegisterLink] phone number', phoneNumber);
        console.log('[RegisterLink] API rate', APIRate);


        return (
            <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '600'}}>
                        {lng === 'cn' ? '后续步骤：注册并保存' : 'Next Steps: Register & Save '}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography>
                        {lng === 'cn'
                            ? '如需预订此货件并管理您的未来订单，请在我们的平台上创建您的官方账户。只需一分钟即可开始：'
                            : 'To book this shipment and manage your future orders, please create your official account on our platform. It only takes a minute to get started:'}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Link href="https://app.uucargo.ca"
                          target="_blank"
                          rel="noopener"
                          underline="hover">
                        <Typography>
                            {lng === 'cn' ? '点击此处注册：app.uucargo.ca' : 'Register Here: app.uucargo.ca'}
                        </Typography>
                    </Link>
                </Grid>
                <Grid size={{xs: 12}}>
                    {
                        loading ?
                            <Box>
                                <CircularProgress/>
                            </Box>
                            :
                            success ?
                                <>
                                    <Typography>
                                        {lng === 'cn' ?
                                            '注册成功！请检查您的邮箱以激活账号。以下是您的临时密码，请在登录后重新设置密码。' :
                                            'Sign-up successful! Please check your email to activate your account. Your temporary password is shown below; please reset it after logging in.'}
                                    </Typography>
                                    <Typography sx={{textAlign: 'center', fontWeight: '600'}}>
                                        {account?.tempPassword}
                                    </Typography>
                                </>
                                :
                                error ?
                                    <Typography>
                                        {lng === 'cn' ? '注册失败。如需完成注册，请点击上方链接。' : 'Sign-up failed. To complete your registration, please click the link above.'}
                                    </Typography>
                                    :
                                    (!isEmailExist) &&
                                    <Button
                                        variant='contained'
                                        onClick={handleQuickSignUp}>
                                        <Typography>
                                            {lng === 'cn' ? '快速注册' : 'Quick Sign Up'}
                                        </Typography>
                                    </Button>
                    }
                </Grid>
            </Grid>
        )
    }

    const Coupon = () => {
        return (
            <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '600'}}>
                        {lng === 'cn' ? '特别欢迎礼包' : 'A Special Welcome Gift'}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography>
                        {lng === 'cn' ? (
                            <>
                                为了感谢您开启首次货运，我们为您提供服务费用 <span
                                style={{fontWeight: '600'}}>$5</span> 的优惠。请在结账时使用以下优惠码：
                            </>
                        ) : (
                            <>
                                To help you get started with your first shipment, we’d like to offer you a <span
                                style={{fontWeight: '600'}}>$5</span> discount on our
                                services. Please use the coupon code below at checkout:
                            </>
                        )}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '600'}}>
                        UUCREGFEBX5
                    </Typography>
                </Grid>
            </Grid>
        )
    }

    const Feedback = () => {

        const [loading, setLoading] = useState(false);
        const [hasSubmit, setHasSubmit] = useState(false);
        const [openPopup, setOpenPopup] = useState(false);

        const updateWebQuoteHistoryLikeOrDislike = async ({like = 0, dislike = 0}) => {

            let requestURL = `${NODE_ROUTE_URI}/webQuoteHistory/updateWebQuoteHistoryLikeOrDislike`;
            try {
                setLoading(true);
                setHasSubmit(true);
                const data = {
                    userEmail: emailAddress,
                    shipmentTypeGroupId: service?.shipmentTypeGroupId,
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province,
                    shipFromCountry: movingFrom?.country,
                    shipToCity: movingTo?.city,
                    shipToProvince: movingTo?.province,
                    shipToCountry: movingFrom?.country,
                    likeIt: like,
                    dislikeIt: dislike
                }

                await axios({
                    method: "POST",
                    url: requestURL,
                    data: data

                })
            } catch (e) {

            } finally {
                setLoading(false);
            }
        }

        useEffect(() => {
            let timer;
            timer = setTimeout(() => {
                setOpenPopup(true);
            }, 15000);

            return () => {
                if (timer) clearTimeout(timer);
            };
        }, []);

        console.log('[Feedback] moving from', movingFrom);
        console.log('[Feedback] moving to', movingTo);
        console.log('[Feedback] moving service', service);
        console.log('[Feedback] moving emailAddress', emailAddress);

        return (
            <>
                <Grid container spacing={2}>
                    <Grid size={{xs: 12}}>
                        <Typography variant='subtitle1' sx={{fontWeight: '600'}}>
                            {lng === 'cn' ? '您的体验对我们很重要' : 'Your feedback matters'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Typography variant='body2'>
                            {lng === 'cn' ? '您对这个报价满意吗？' : 'Are you happy with this quote?'}
                        </Typography>
                    </Grid>
                    <FlexBox justifyContent='flex-start'>
                        <Button
                            onClick={() => updateWebQuoteHistoryLikeOrDislike({like: 1})}
                            disabled={hasSubmit}
                            loading={loading}>
                            👍
                        </Button>
                        <Button
                            onClick={() => updateWebQuoteHistoryLikeOrDislike({dislike: 1})}
                            disabled={hasSubmit}
                            loading={loading}>
                            👎
                        </Button>
                    </FlexBox>
                    {
                        hasSubmit &&
                        <Typography variant='caption'>
                            {lng === 'cn' ? '感谢您的反馈' : 'Thank you!'}
                        </Typography>
                    }
                </Grid>
                <Dialog
                    open={openPopup}
                    onClose={() => setOpenPopup(false)}
                >
                    <DialogTitle sx={{m: 0, p: 2, fontWeight: 700}}>
                        {lng === 'cn' ? '满意我们的报价吗？' : 'Happy with the quote?'}
                        <IconButton
                            onClick={() => setOpenPopup(false)}
                            sx={{position: 'absolute', right: 8, top: 8}}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" sx={{mb: 2}}>
                            {lng === 'cn'
                                ? '只需一秒，告诉我们您的想法！'
                                : 'Takes just a second to let us know!'}
                        </Typography>
                        <FlexBox justifyContent='center' gap={4}>
                            <Button
                                onClick={() => updateWebQuoteHistoryLikeOrDislike({like: 1})}
                                disabled={hasSubmit}
                            >
                                <Typography>👍</Typography>
                            </Button>
                            <Button
                                onClick={() => updateWebQuoteHistoryLikeOrDislike({dislike: 1})}
                                disabled={hasSubmit}
                            >
                                <Typography>👎</Typography>
                            </Button>
                        </FlexBox>
                        {hasSubmit && (
                            <Typography align="center" sx={{mt: 2, color: 'green', fontWeight: 600}}>
                                {lng === 'cn' ? '感谢反馈！' : 'Feedback Received!'}
                            </Typography>
                        )}
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    return (
        <Grid container spacing={0}>
            <Grid size={{xs: 12}}>
                {
                    chat?.role === 'model' ?
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            {
                                (chat?.data && (chat?.status === 1 || chat?.status === 0)) &&
                                <Box
                                    component="pre"
                                    sx={{
                                        borderRadius: 1,
                                        overflow: 'auto',
                                        fontSize: '14px',
                                        lineHeight: 1.5,
                                    }}
                                >
                                    <WordPressMultiConversationChatBotShippingInformation lng={lng}
                                                                                          shippingInformation={chat?.data}
                                                                                          service={service}/>
                                    {/*{JSON.stringify(chat?.data, null, 2)}*/}
                                </Box>
                            }
                            {
                                (chat?.data && chat?.status === 4) &&
                                <Box
                                    sx={{
                                        borderRadius: 1,
                                        overflow: 'auto',
                                        fontSize: '14px',
                                        lineHeight: 1.5,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        width: '100%',
                                        height: 'auto',
                                    }}
                                >
                                    <WordPressMultiConversationChatBotRate lng={lng}
                                                                           rateInformation={chat?.data}
                                                                           service={service}
                                                                           packageRate={packageRate}
                                                                           packageLoading={packageLoading}
                                                                           packageError={packageError}
                                                                           isAbleGetPackageRate={isAbleGetPackageRate}/>
                                </Box>
                            }
                            {
                                chat?.status !== 1 &&
                                <Typography>
                                    {chat?.parts?.[0]?.text}
                                </Typography>
                            }
                            {
                                (chat?.status === 1) &&
                                <Box>
                                    {
                                        (chat?.data?.package?.reduce((sum, item) => sum + +item.quantity, 0) >= 8) ?
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '5px'
                                                }}
                                            >
                                                <Typography>
                                                    {
                                                        lng === 'cn' ? '总数量超过8件。请选择搬家服务。' :
                                                            'The total quantity exceeds 8 items. Please select Moving Service.'
                                                    }
                                                </Typography>
                                                <Box sx={{
                                                    display: 'flex',
                                                    gap: '10px'
                                                }}>
                                                    <Button
                                                        variant='contained'
                                                        size='small'
                                                        onClick={() => cbHandleMovingService(chat)}
                                                        disabled={chat?.status !== status || index !== chatLength}
                                                    >
                                                        <Typography sx={{textTransform: 'none', fontSize: '14px'}}>
                                                            {lng === 'cn' ? '搬家服务' : 'Moving Service'}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            </Box>
                                            :
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '5px'
                                                }}
                                            >
                                                <Typography>
                                                    {chat?.parts?.[0]?.text}
                                                </Typography>
                                                <Box sx={{
                                                    display: 'flex',
                                                    gap: '10px'
                                                }}>
                                                    <Button
                                                        variant='contained'
                                                        size='small'
                                                        onClick={cbHandleConfirm}
                                                        disabled={chat?.status !== status || index !== chatLength}
                                                    >
                                                        <Typography sx={{textTransform: 'none', fontSize: '14px'}}>
                                                            {lng === 'cn' ? '确认' : 'Confirm'}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            </Box>
                                    }
                                </Box>
                            }
                            {
                                chat?.status === 4 &&
                                <Box
                                    component="pre"
                                    sx={{
                                        borderRadius: 1,
                                        overflow: 'auto',
                                        fontSize: '14px',
                                        lineHeight: 1.5,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                    }}
                                >
                                    <Feedback/>
                                    <RegisterLink/>
                                    <Coupon/>
                                </Box>
                            }
                        </Box>
                        :
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}>
                            <Box sx={{
                                backgroundColor: '#DCDCDC',
                                padding: '10px 20px',
                                borderRadius: '8px',
                                maxWidth: '65vw'
                            }}>
                                <Typography>
                                    {chat?.parts?.[0]?.text}
                                </Typography>
                            </Box>
                        </Box>
                }
            </Grid>
        </Grid>
    )
}